import { inject, Injectable } from '@angular/core';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RoleService } from '@lib-ui/lib/services/role.service';
import { UserService } from '@lib-ui/lib/services/user.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AccessControlRole } from '@lib-ui/lib/models/access-control-role';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { LoadingState } from '@lib-ui/lib/models';

/**
 * NOTE(js): Poor mans access control
 */
@Injectable({
  providedIn: 'root',
})
export class AccessControlService {
  private readonly roleService = inject(RoleService);
  private readonly userService = inject(UserService);
  private readonly status$ = toObservable(this.roleService.state.status);
  private readonly user$ = toObservable(this.userService.state.user);

  constructor() {
    this.user$.pipe(
      filter(user => !!user),
      takeUntilDestroyed(),
    ).subscribe(() => this.roleService.load());
  }

  public hasAccess(
    route: ActivatedRouteSnapshot | { data: { roles: Array<string> } },
  ): Observable<boolean> {
    const roles = (route.data?.roles ?? []) as Array<string>;
    return this.status$.pipe(
      filter(status => status != LoadingState.Pending),
      map(() => this.hasRoleAccess(roles)),
    );
  }

  private hasRoleAccess(roles: string[]): boolean {
    const role = this.roleService.state.role();
    if (!role) {
      return false;
    }
    if (role.name == AccessControlRole.Admin) {
      return true;
    }
    return roles.includes(role.name);
  }
}
